export const actionTypes: any = {
  GET_FD_TYPE_START: 'GET_FD_TYPE_START',
  GET_FD_TYPE_SUCCESS: 'GET_FD_TYPE_SUCCESS',
  GET_FD_TYPE_FINISH: 'GET_FD_TYPE_FINISH',

  ADD_FD_TYPE_START: 'ADD_FD_TYPE_START',
  ADD_FD_TYPE_SUCCESS: 'ADD_FD_TYPE_SUCCESS',
  ADD_FD_TYPE_FINISH: 'ADD_FD_TYPE_FINISH',
  ADD_FD_TYPE_RESET: 'ADD_FD_TYPE_RESET',

  UPDATE_FD_TYPE_START: 'UPDATE_FD_TYPE_START',
  UPDATE_FD_TYPE_SUCCESS: 'UPDATE_FD_TYPE_SUCCESS',
  UPDATE_FD_TYPE_FINISH: 'UPDATE_FD_TYPE_FINISH',
  UPDATE_FD_TYPE_RESET: 'UPDATE_FD_TYPE_RESET',

  DELETE_FD_TYPE_START: 'DELETE_FD_TYPE_START',
  DELETE_FD_TYPE_SUCCESS: 'DELETE_FD_TYPE_SUCCESS',
  DELETE_FD_TYPE_FINISH: 'DELETE_FD_TYPE_FINISH',

  SINGLE_ACTIVATE_FD_TYPE_REQUEST: 'SINGLE_ACTIVATE_FD_TYPE_REQUEST',
  SINGLE_ACTIVATE_FD_TYPE_SUCCESS: 'SINGLE_ACTIVATE_FD_TYPE_SUCCESS',
  SINGLE_ACTIVATE_FD_TYPE_FINISH: 'SINGLE_ACTIVATE_FD_TYPE_FINISH',

  SINGLE_DEACTIVATE_FD_TYPE_REQUEST: 'SINGLE_DEACTIVATE_FD_TYPE_REQUEST',
  SINGLE_DEACTIVATE_FD_TYPE_SUCCESS: 'SINGLE_DEACTIVATE_FD_TYPE_SUCCESS',
  SINGLE_DEACTIVATE_FD_TYPE_FINISH: 'SINGLE_DEACTIVATE_FD_TYPE_FINISH',

  SORT_FD_TYPE_START: 'SORT_FD_TYPE_START',
  SORT_FD_TYPE_SUCCESS: 'SORT_FD_TYPE_SUCCESS',
  SORT_FD_TYPE_FINISH: 'SORT_FD_TYPE_FINISH',
  SORT_FD_TYPE_RESET: 'SORT_FD_TYPE_RESET',
}
